import { useEffect, useState } from 'react';
import styled from 'styled-components';
import SignUpSerivce from '../../service/signUp/SignUp';
import { useNavigate } from 'react-router-dom';

const FindPassword = ({ providedUserid, providedPhone, providedName }: any) => {
  const navigate = useNavigate();

  const [phone, setPhone] = useState('');
  const [id, setId] = useState('');
  const [name, setName] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (providedUserid) {
      setEmail(providedUserid);
      setIsEmailValid(true);
      setEmailValidState({
        //유효성 체크 검사 및 사용가능한 이메일인 경우
        isValid: true,
        text: '',
      });
    }
    providedPhone && setPhone(providedPhone);
    providedName && setName(providedName);
  }, [providedUserid, providedPhone, providedName]);

  const [nameError, setNameError] = useState('');

  const [phoneError, setPhoneError] = useState<string | null>(null);
  const [sendSms, setSendSms] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [verifiedCode, setVerifiedCode] = useState('');
  const [codeError, setCodeError] = useState<string | null>(null);
  const [isButtonActive, setIsButtonActive] = useState(false);
  const [isVerifiedCode, setIsVerifiedCode] = useState(false); // ✅ API 성공 여부 상태
  const [email, setEmail] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [emailDuplicateYN, setEmailDuplicateYN] = useState(true);
  const [emailValidState, setEmailValidState] = useState({
    isValid: true,
    text: '',
  });
  const [isEmailCheckYN, setIsEmailCheckYN] = useState(false);
  const [isCheckCode, setIsCheckCode] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordError, setPasswordError] = useState<string | null>(null);
  const [passwordCheck, setPasswordCheck] = useState('');
  const [passwordMatch, setPasswordMatch] = useState(false);
  const [passwordCheckFocused, setPasswordCheckFocused] = useState(false); // 포커스 여부 상태 추가

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleEmailChange = (e: any) => {
    if (providedUserid) {
    }
    const newEmail = e.target.value;
    setEmail(newEmail);
    setEmailDuplicateYN(false);
    setIsEmailCheckYN(false);
    if (newEmail === '') {
      setIsEmailValid(false);
    } else if (!validateEmail(newEmail)) {
      setIsEmailValid(false);
    } else {
      setIsEmailValid(true);
    }
  };

  const validatePassword = (password: string) => {
    const passwordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,16}$/;
    return passwordRegex.test(password);
  };
  useEffect(() => {
    if (password.length === 0) {
      setPasswordError(null); // ✅ null로 설정
      setPasswordMatch(false);
      setPasswordCheckFocused(false);
      setPasswordCheck(''); // ✅ 비밀번호가 비어있으면 비밀번호 확인도 비워줌
      return;
    }
    if (password || passwordCheck) {
      // Only validate if any of the fields are filled
      setPasswordMatch(password === passwordCheck);
      setPasswordError(
        validatePassword(password)
          ? null
          : '8~16자의 영문, 숫자, 특수문자를 조합하여 입력해주세요.',
      );
    }
  }, [password, passwordCheck]);

  const RenderEmailText = () => {
    if (email.length === 0) {
      setEmailValidState({
        isValid: true,
        text: '',
      });
    } else if (!isEmailValid) {
      setEmailValidState({
        isValid: false,
        text: '이메일 형식에 맞게 입력해주세요.',
      });
    } else if (isEmailValid && !isEmailCheckYN) {
      setEmailValidState({
        isValid: true,
        text: '',
      });
    } else if (emailDuplicateYN && isEmailCheckYN) {
      setEmailValidState({
        isValid: false,
        text: '이미 사용중인 이메일입니다.',
      });
    } else {
      setEmailValidState({
        //유효성 체크 검사 및 사용가능한 이메일인 경우
        isValid: true,
        text: '',
      });
    }
  };

  const postSms = async () => {
    if (email === '' || phone === '') {
      alert('이메일과 휴대폰 번호를 입력해주세요');
      return;
    }
    if (!isEmailValid) {
      alert('이메일 형식에 맞게 입력해주세요.');
      return;
    }
    if (nameError.length > 0) {
      alert('이름을 입력해주세요.');
      return;
    }
    try {
      const result = await SignUpSerivce.SendSms({
        type: 'P',
        loginType: 'C',
        userid: email,
        tel: phone,
        name: name,
      });
      if (result.status === 'success') {
        setSendSms(true);
      }
    } catch (error: any) {
      alert(error.response.data.message);
      console.log(error);
    }
  };

  const CheckCode = async () => {
    try {
      const result = await SignUpSerivce.CheckCode({
        type: 'P',
        loginType: 'C',
        userid: email,
        tel: phone,
        name: name,
        authCode: verifiedCode,
      });
      setIsCheckCode(result.status === 'success');
      return result.status === 'success';
    } catch (error: any) {
      // alert(error.response.data.message);
      console.log(error);
      setIsCheckCode(false);

      return false;
    }
  };

  const handleNameChange = (e: any) => {
    const newName = e.target.value;
    setName(newName);
  };

  const handlePhoneChange = (e: any) => {
    const value = e.target.value;
    setPhone(value);
    setIsButtonActive(false);
    setIsVerifiedCode(false);
    setIsPhoneValid(false);
    setSendSms(false);
    if (value.length === 0) {
      setPhoneError(null);
      setIsPhoneValid(true);
      return;
    }

    if (!value.startsWith('010')) {
      setPhoneError('휴대폰 형식이 맞지 않습니다.');
      setIsPhoneValid(false);
      return;
    }

    if (value.length !== 11) {
      setPhoneError('휴대폰 번호를 입력하세요.');
      setIsPhoneValid(false);
      return;
    }

    setPhoneError(null);
    setIsPhoneValid(true);
  };

  const handleCodeChange = (e: any) => {
    const value = e.target.value;
    setVerifiedCode(value);
    setIsVerifiedCode(false);
    if (value.length === 0) {
      setCodeError('메시지가 오지 않을 경우 재전송을 눌러주세요.');
      return;
    }

    if (value.length !== 6) {
      setCodeError('인증번호를 6자리 입력해주세요.');
      return;
    }

    if (value.length === 6) {
      setCodeError(null);
      setIsButtonActive(true);
      return;
    }
  };

  useEffect(() => {
    if (phone.length === 0) {
      setPhoneError(null); // 입력값이 없으면 에러 메시지 없음
      setIsPhoneValid(true);
      return;
    }

    if (!phone.startsWith('010')) {
      setPhoneError('휴대폰 형식이 맞지 않습니다.');
      setIsPhoneValid(false);
      return;
    }

    if (phone.length !== 11) {
      setPhoneError('휴대폰 번호를 입력하세요.');
      setIsPhoneValid(false);
      return;
    }

    setPhoneError(null);
    setIsPhoneValid(true);
  }, [phone]);
  useEffect(() => {
    // 숫자가 포함되어 있으면 에러 메시지 설정
    if (/[0-9]/.test(name)) {
      setNameError('숫자는 허용되지 않습니다.');
    } else {
      setNameError('');
    }
  }, [name]);

  useEffect(() => {
    RenderEmailText();
  }, [isEmailValid, isEmailCheckYN, email, emailDuplicateYN]);

  const RenderPassWordText = () => {
    if (passwordError) {
      //비밀번호가 유효하지 않은 경우
      return {
        isValid: false,
        text: <ErrorText>{passwordError}</ErrorText>,
      };
    } else if (
      password.length > 0 &&
      !passwordError &&
      passwordCheckFocused &&
      passwordCheck.length === 0
    ) {
      //비밀번호가 유효하고, 비밀번호 확인에 포커스가 있는 경우
      return {
        isValid: false,
        text: <ErrorText> 비밀번호를 다시 한 번 입력해 주세요.</ErrorText>,
      };
    } else if (
      password.length > 0 &&
      !passwordError &&
      passwordCheck.length === 0
    ) {
      //비밀번호가 유효한 경우
      return {
        isValid: true,
        text: '',
      };
    } else if (!passwordMatch && passwordCheck.length > 0) {
      //비밀번호가 일치하지 않는 경우
      return {
        isValid: false,
        text: (
          <ErrorText>
            {' '}
            비밀번호가 일치하지 않습니다. 확인 후 재 입력해 주세요
          </ErrorText>
        ),
      };
    } else if (passwordMatch && !passwordError && passwordCheck.length > 0) {
      //비밀번호가 일치하고, 비밀번호 확인이 유효한 경우
      return { isValid: true, text: '' };
    } else {
      return {
        //초기값 일경우에는 true
        isValid: password.length === 0 ? true : false,
        text: '8~16자의 영문, 숫자, 특수문자를 조합하여 입력해주세요.',
      };
    }
  };

  const handleVerify = async () => {
    if (!isButtonActive) return;

    setCodeError(null); // 기존 에러 메시지 숨김

    const isValid = await CheckCode();
    if (isValid) {
      setCodeError(null);
      setIsVerifiedCode(true);
    } else {
      setIsVerifiedCode(false);
      setCodeError('인증번호가 일치하지 않습니다. 확인 후 재 입력해 주세요.');
    }
  };

  const changePassword = async () => {
    try {
      const result = await SignUpSerivce.findPassword({
        userid: email,
        phone: phone,
        name: name,
        password: password,
      });
      if (result.status === 'success') {
        alert('비밀번호가 변경되었습니다. 다시 로그인해주세요');
        navigate('/login');
        setIsCheckCode(true);
      }
    } catch (error: any) {
      alert(error.response.data.message);
      console.log(error);
    }
  };

  return (
    <Container>
      {!isCheckCode ? (
        <FormWrapper>
          <FormBox>
            <FormTitle>이메일</FormTitle>
            <InputBoxWrapper>
              <IdInputBox>
                <SignupInput
                  value={email}
                  isValid={emailValidState.isValid}
                  onChange={(e: any) => {
                    handleEmailChange(e);
                    setEmail(e.target.value);
                  }}
                  isavailable={!emailDuplicateYN && isEmailCheckYN}
                  placeholder="아이디를 입력해주세요."
                />
              </IdInputBox>
              {!(!emailDuplicateYN && isEmailCheckYN) &&
                emailValidState.text.length !== 0 && (
                  <InputInfoBox isValid={emailValidState.isValid}>
                    {email.length > 0 && !isEmailValid && (
                      <img
                        src={`/assets/images/icon/${emailValidState.isValid ? 'signUpInfo_icon' : 'signUpInfo_icon_NotValid'}.svg`}
                      />
                    )}
                    <div>{emailValidState.text}</div>
                  </InputInfoBox>
                )}
            </InputBoxWrapper>
          </FormBox>

          <FormBox>
            <FormTitle>성명</FormTitle>
            <SignupInput
              value={name}
              isValid={nameError.length === 0}
              onChange={(e: any) => {
                handleNameChange(e);
              }}
              placeholder="성명을 입력해주세요."
            />
            {nameError.length > 0 && (
              <InputInfoBox isValid={nameError.length === 0}>
                <img
                  src={`/assets/images/icon/${nameError.length === 0 ? 'signUpInfo_icon' : 'signUpInfo_icon_NotValid'}.svg`}
                />
                <ErrorText>{nameError}</ErrorText>
              </InputInfoBox>
            )}
          </FormBox>
          <FormBox>
            <FormTitle>휴대폰 번호</FormTitle>
            <InputBoxWrapper>
              <IdInputBox>
                <SignupInput
                  value={phone}
                  isValid={(phoneError?.length ?? 0) === 0}
                  onChange={(e: any) => {
                    handlePhoneChange(e);
                  }}
                  placeholder="휴대폰 번호를 입력해주세요."
                  maxLength={11}
                  isavailable={isButtonActive && isVerifiedCode}
                />
                <CheckValidButton
                  onClick={
                    isPhoneValid &&
                    phone.length > 0 &&
                    nameError.length === 0 &&
                    email.length > 0 &&
                    emailValidState.isValid
                      ? () => {
                          postSms();
                        }
                      : () => {}
                  }
                  isValid={
                    isPhoneValid &&
                    phone.length > 0 &&
                    nameError.length === 0 &&
                    email.length > 0 &&
                    emailValidState.isValid
                  }
                  sendYN={sendSms}
                  available={isButtonActive && isVerifiedCode}
                  text={
                    isButtonActive && isVerifiedCode
                      ? '인증완료'
                      : sendSms
                        ? '재전송'
                        : '인증번호발송'
                  }
                >
                  {isButtonActive && isVerifiedCode
                    ? '인증완료'
                    : sendSms
                      ? '재전송'
                      : '인증번호발송'}
                </CheckValidButton>
              </IdInputBox>
              {sendSms && (
                <IdInputBox>
                  <SignupInput
                    isValid={(codeError?.length ?? 0) === 0}
                    onChange={(e: any) => {
                      handleCodeChange(e);
                    }}
                    placeholder="인증번호 6자리를 입력해주세요."
                    maxLength={6}
                    isavailable={isButtonActive && isVerifiedCode}
                  />
                  <CheckValidButton
                    onClick={() => {
                      handleVerify();
                    }}
                    available={isButtonActive && isVerifiedCode}
                    isValid={isPhoneValid && phone.length > 0}
                    text={
                      isButtonActive && isVerifiedCode ? '인증완료' : '확인'
                    }
                  >
                    {isButtonActive && isVerifiedCode ? '인증완료' : '확인'}
                  </CheckValidButton>
                </IdInputBox>
              )}
              {(phoneError?.length ?? 0) > 0 && (
                <InputInfoBox isValid={phoneError?.length === 0}>
                  <img
                    src={`/assets/images/icon/${phoneError?.length === 0 ? 'signUpInfo_icon' : 'signUpInfo_icon_NotValid'}.svg`}
                  />
                  <ErrorText>{phoneError}</ErrorText>
                </InputInfoBox>
              )}
              {(codeError?.length ?? 0) > 0 && (
                <InputInfoBox
                  isValid={
                    codeError?.length === 0 ||
                    (codeError?.includes('재전송') ?? false)
                  }
                >
                  <img
                    src={`/assets/images/icon/${
                      codeError?.length === 0 ||
                      (codeError?.includes('재전송') ?? false)
                        ? 'signUpInfo_icon'
                        : 'signUpInfo_icon_NotValid'
                    }.svg`}
                  />
                  <ErrorText>{codeError}</ErrorText>
                </InputInfoBox>
              )}
            </InputBoxWrapper>
          </FormBox>
        </FormWrapper>
      ) : (
        <FormWrapper>
          <FormBox>
            <FormTitle>비밀번호 변경하기</FormTitle>
            <SignupInput
              value={password} // ✅ 비밀번호 값을 상태와 연결
              isValid={(passwordError?.length ?? 0) > 0 ? false : true}
              type={passwordVisible ? 'text' : 'password'}
              onChange={(e: any) => {
                setPassword(e.target.value);
              }}
              placeholder="비밀번호를 입력해주세요"
            />
            <div style={{ width: '100%' }}>
              <SignupInput
                isValid={passwordMatch}
                type={passwordVisible ? 'text' : 'password'}
                value={passwordCheck} // ✅ 비밀번호 확인 값을 상태와 연결
                onChange={(e: any) => {
                  setPasswordCheck(e.target.value);
                }}
                onFocus={() => setPasswordCheckFocused(true)} // ✅ 포커스 얻으면 true
                onBlur={() => setPasswordCheckFocused(false)} // ✅ 포커스 잃으면 false
                placeholder="비밀번호 확인"
              />
            </div>
            <VisibleButton>
              <img
                onClick={() => {
                  setPasswordVisible((prev) => !prev);
                }}
                src={`/assets/images/icon/${passwordVisible ? 'Visible_icon' : 'notVisible_icon'}.svg`}
              ></img>
            </VisibleButton>
            <div
              style={{
                height:
                  passwordMatch && !passwordError && passwordCheck.length > 0
                    ? '0px'
                    : '40px',
              }}
            >
              {(password.length === 0 || !RenderPassWordText().isValid) && (
                <InputInfoBox isValid={RenderPassWordText().isValid}>
                  <img
                    src={`/assets/images/icon/${RenderPassWordText().isValid ? 'signUpInfo_icon' : 'signUpInfo_icon_NotValid'}.svg`}
                  />
                  <div
                    style={{
                      position: 'relative',
                      // marginBottom:
                      //   password.length === 0 ? '20px' : undefined,
                    }}
                  >
                    <div>{RenderPassWordText().text}</div>
                    {password.length === 0 && (
                      <SpecialCharTag>
                        (사용 가능한 특수문자 ! ? @ # $ % * &)
                      </SpecialCharTag>
                    )}
                  </div>
                </InputInfoBox>
              )}
            </div>
          </FormBox>
          {passwordMatch && !passwordError && passwordCheck.length > 0 && (
            <ChangePasswordBox
              onClick={() => {
                changePassword();
              }}
            >
              비밀번호 변경
            </ChangePasswordBox>
          )}
        </FormWrapper>
      )}
    </Container>
  );
};

export default FindPassword;

const ChangePasswordBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
  background-color: #008aff;
  color: #ffffff;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  line-height: 23.2px;
`;

const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ErrorText = styled.span`
  color: red;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 13px;
  line-height: 20.3px;
  word-wrap: break-word;
`;

interface InputBoxProps {
  isValid: boolean;
  isavailable?: boolean;
}

const SignupInput = styled.input<InputBoxProps>`
  border-radius: 8px;
  // border: 1px solid #171e2666;
  // border-color: #171e2666;
  padding-inline: 16px;
  padding-block: 12px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  line-height: 23.2px;
  text-align: left;
  width: 100%;
  border: none;
  ::placeholder {
    color: #171e2666;
  }
  &:focus {
    outline: none; /* 기본 브라우저 스타일 제거 */
    // border: 1px solid #008aff; /* 보라색 테두리 */

    border: 1px solid ${(props) => (props.isValid ? '#008AFF' : 'red')};
  }

  color: ${(props) =>
    props.isavailable ? 'rgba(55, 56, 60, 0.16);' : '#616161'};
  background-color: ${(props) =>
    props.isavailable ? 'rgba(112, 115, 124, 0.08)' : '#F5F7FA'};
`;

const InputBoxWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

interface ValidProps {
  isValid: boolean;
  sendYN?: boolean;
  available?: boolean;
  text?: string;
}

const InputInfoBox = styled.div<ValidProps>`
  color: ${(props) => (props.isValid ? 'rgba(55, 56, 60, 0.61)' : '#FF0000')};
  display: flex;
  flex-direction: row;
  gap: 6px;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
`;

const getButtonStyles = (props: ValidProps) => {
  if (props.available) {
    return {
      backgroundColor: '#989BA2',
      color: '#ffffff',
      cursor: 'null',
    };
  }

  if (props.sendYN) {
    return {
      border: '1px solid #008AFF',
      backgroundColor: '#FFFFFF',
      color: '#008AFF',
      cursor: 'pointer',
    };
  }
  if (props.isValid) {
    return {
      backgroundColor: '#008AFF',
      color: '#ffffff',
      cursor: 'pointer',
    };
  }

  return {
    backgroundColor: '#f7f7f8',
    color: '#616161',
    cursor: 'null',
  };
};

const CheckValidButton = styled.div<ValidProps>`
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-family: 'Spoqa Han Sans Neo', 'sans-serif';
  font-weight: 500;
  line-height: 26.4px;
  word-wrap: break-word;
  white-space: nowrap;
  text-align: center;
  border: ${(props) => getButtonStyles(props).border};
  background-color: ${(props) => getButtonStyles(props).backgroundColor};
  color: ${(props) => getButtonStyles(props).color};
  cursor: ${(props) => getButtonStyles(props).cursor};
  width: ${(props) =>
    props.text === '재전송' || props.text === '확인' ? '84px' : 'auto'};
`;

const IdInputBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  //   gap: 12px;
`;

const FormTitle = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  line-height: 23.2px;
  text-align: center;
`;

const FormBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
`;

const SpecialCharTag = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  line-height: 18.85px;
  text-align: left;
  color: rgba(55, 56, 60, 0.61);
  position: absolute;
  top: 14px;
  right: 96px;
  white-space: nowrap;
  margin-bottom: 20px;
`;
const InfoText = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  line-height: 18.85px;
  text-align: left;
  color: rgba(55, 56, 60, 0.61);
`;

const VisibleButton = styled.div`
  position: absolute;
  top: 53px;
  right: 15px;
  img {
    width: 20px;
    height: 20px;
  }
`;
